import TextTag from "../../components/Tag";
import { FiPlus, FiPlay, FiTrendingUp } from "react-icons/fi";

const STEPS = [
  {
    number: "01",
    icon: <FiPlus size={22} />,
    title: "Create activities",
    description:
      "Add the things you do daily — work, exercise, reading — and assign each a unique color.",
  },
  {
    number: "02",
    icon: <FiPlay size={22} />,
    title: "Log your sessions",
    description:
      "Tap to start a timer when you begin. Stop when you're done. Simple as that.",
  },
  {
    number: "03",
    icon: <FiTrendingUp size={22} />,
    title: "See your patterns",
    description:
      "Your 24-hour clock and weekly charts reveal exactly where your time goes.",
  },
];

const HowItWorks = () => {
  return (
    <section className="hiw">
      <div className="hiw__header">
        <TextTag text="How it works" />
        <h2 className="hiw__title">Three steps to own your day</h2>
        <p className="hiw__sub">
          No setup, no subscriptions. Just open the app and start tracking.
        </p>
      </div>

      <div className="hiw__grid">
        {STEPS.map((step, index) => (
          <div className="hiw__card" key={step.number}>
            {/* Added the top section to display Icon and Number */}
            <div className="hiw__card-top">
              <div className="hiw__icon">{step.icon}</div>
              <span className="hiw__number">{step.number}</span>
            </div>

            <h3 className="hiw__card-title">{step.title}</h3>
            <p className="hiw__card-desc">{step.description}</p>

            {/* Horizontal connector for desktop views */}
            {index < STEPS.length - 1 && <div className="hiw__connector" />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
